"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScoringUnscorableReasonItems = void 0;
exports.ScoringUnscorableReasonItems = ["cheating", "incomplete", "wrong_language", "other"];
